module.exports = __webpack_public_path__ + "media/images/affiliation_logos/affiliate_logo_varian-a5dde90d828d04ec4db31aff6d4d23e0.png";